import styled from 'styled-components';

export const ModalStyled = styled.dialog<{
  show?: boolean;
  fitContent?: boolean;
}>`
  display: ${(props) => (props.show ? 'flex' : 'none')};
  flex-direction: column;
  ${(props) =>
    !props.fitContent &&
    `min-height: 700px;
    width: min(940px, 100vw);
  `}
  padding: 0;
  border-radius: 4px;
  border: none;
  box-shadow:
    0px 0px 1px 0px rgba(0, 0, 0, 0.4),
    0px 12px 12px -6px rgba(0, 0, 0, 0.16);
  ::backdrop {
    background-color: #000000;
    opacity: 0.7;
  }
`;

export const ContentContainer = styled.div<{ fitContent?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  ${(props) =>
    !props.fitContent &&
    `height: 700px;
    min-width: 940px;
  `}
  overflow-x: auto;
`;

export const TitleContainer = styled.div<{ removePadding?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  ${(props) => !props.removePadding && 'padding: 0 20px;'}
`;

export const FooterContainer = styled.div<{ removePadding?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  ${(props) => !props.removePadding && 'padding: 0 20px;'}
  min-height: 60px;
`;
